import React, { useRef, useState } from 'react';
import { View, StyleSheet, FlatList, TouchableOpacity, ScrollView } from 'react-native';
import TextInput from '../textInput/TextInput';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, InputStateToken, KeyboardTypeToken } from '@voltmoney/schema';
import Typography from '../typography/Typography';
const DropDownComp = ({ label = '', Data, value, onValueSelect, }) => {
    const searchRef = useRef();
    const [data, setData] = useState(Data);
    const [tempData, setTempdData] = useState(Data);
    const [search, setSearch] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedItem, setSlectedItem] = useState(undefined);
    const [dropDownheight, setDropDownHeight] = useState(160);
    const onSelect = (item) => {
        setShowDropdown(false);
        onValueSelect(item);
        setSlectedItem(item);
    };
    const filterData = () => {
        if (searchQuery !== '') {
            const newData = data.filter((item) => item.label.toLowerCase().includes(searchQuery.toLowerCase()));
            setTempdData(newData);
            if (newData?.length >= 4) {
                setDropDownHeight(160);
            }
            else if (newData?.length == 3) {
                setDropDownHeight(120);
            }
            else if (newData?.length == 2) {
                setDropDownHeight(80);
            }
            else if (newData?.length == 1) {
                setDropDownHeight(40);
            }
            else
                setDropDownHeight(0);
        }
        else {
            setTempdData(Data);
            setDropDownHeight(160);
        }
    };
    return (React.createElement(View, { style: styles.container },
        React.createElement(TextInput, { state: InputStateToken.DEFAULT, value: selectedItem ? selectedItem?.label : '', keyboardType: KeyboardTypeToken.default, onChangeText: (text) => {
                setSearchQuery(text);
                filterData();
            }, placeholder: label, onPress: () => setShowDropdown(!showDropdown) }),
        showDropdown && (React.createElement(View, { style: styles.dropdownContainer },
            React.createElement(ScrollView, { style: [styles.dropdown, { height: dropDownheight, borderWidth: dropDownheight > 0 ? 1 : 0 }] },
                React.createElement(FlatList, { data: tempData, keyExtractor: (item) => item.value, renderItem: ({ item }) => (React.createElement(TouchableOpacity, { style: styles.item, onPress: () => onSelect(item) },
                        React.createElement(Typography, { label: item.label, color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.SM, fontWeight: '500', fontFamily: FontFamilyTokens.Inter, lineHeight: 20 }))) }))))));
};
const styles = StyleSheet.create({
    container: {
        position: 'relative',
        zIndex: 1,
    },
    dropdown: {
        marginTop: 20,
        alignSelf: 'center',
        width: '100%',
        backgroundColor: 'white',
        borderRadius: 8,
        borderColor: '#E4E7EC',
        // borderWidth: 1,
        shadowColor: '#0C5637',
        shadowOpacity: 0.08,
        elevation: 5,
        shadowOffset: {
            width: 10,
            height: 10,
        },
        shadowRadius: 16,
    },
    dropdownContainer: {
        position: 'absolute',
        top: 40,
        left: 0,
        right: 0,
        zIndex: 1000,
    },
    item: {
        padding: 10,
        borderBottomWidth: 1,
        borderBottomColor: '#E4E7EC',
    },
});
export default DropDownComp;
